import { Navigate } from 'react-router-dom';
import { useAuth } from '../../providers/authProvider';
 
function PrivateRoute({ children }) {
    const auth = useAuth();
  
    if (!auth.isLoggedIn) {
      return  <Navigate to="/login"  /> 
    } 
    return children;
  }


export default PrivateRoute;
